// extracted by mini-css-extract-plugin
module.exports = {"list":"SizesList_list__GMdr7","unavailable":"SizesList_unavailable__5x_z1","notAvailable":"SizesList_notAvailable__zX32o"};